<template>
	<v-autocomplete
		:value="value"
		:rules="rules"
		@change="$emit('change', $event)"
		:items="items"
		:loading="loading"
		item-text="name"
		item-value="code"
		:search-input.sync="search"
		:readonly="readonly"
		:disabled="disabled"
		:solo="solo"
		:hide-details="hide_details"
		dense
		:menu-props="{contentClass: 'select-background-base'}"
		hide-no-data
		:append-icon="''"
		:class="{ dense_input: dense }"
		:clearable="clearable"
		@click:clear="$emit('change', null)"
		:placeholder="placeholder || 'Rechercher un ayant-droit'"
		:hint="hint">
		<template v-slot:label>
			<span v-if="param">
				{{ param | maestroParamLabel }}
			</span>
		</template>
		<template v-slot:selection="{ item }">
			<v-list-tile-content
				:title="`${item.code} | ${item.name}`">
				<v-list-tile-title>{{ item.name }}</v-list-tile-title>
			</v-list-tile-content>
		</template>
		<template v-slot:item="{ item }">
			<v-list-tile-content
				:title="`${item.code} | ${item.name}`">
				<v-list-tile-title>{{ item.name }}</v-list-tile-title>
				<v-list-tile-sub-title>{{ item.code }}</v-list-tile-sub-title>
			</v-list-tile-content>
			<v-list-tile-action>
				<v-btn
					flat icon
					:title="`copier le code client ${item.code}`"
					@click.stop="copyOwnerCode(item.code)">
					<v-icon small>content_copy</v-icon>
				</v-btn>
			</v-list-tile-action>
		</template>
		<template v-slot:append>
			<v-btn
				v-if="value"
				small flat icon
				class="ma-0"
				:title="`copier le code client ${value}`"
				@click.stop="copyOwnerCode(value)">
				<v-icon small>content_copy</v-icon>
			</v-btn>
		</template>
	</v-autocomplete>
</template>

<script>
import { debounce } from 'debounce'
export default {
	props: [
		'value',
		'rules',
		'param',
		'hint',
		'readonly',
		'solo',
		'dense',
		'disabled',
		'hide_details',
		'clearable',
		'placeholder'
	],
	data () {
		return {
			items: [],
			names: [],
			search: null,
			loading: false
		}
	},
	watch: {
		search (val) {
			if (val && this.names.indexOf(val) === -1) {
				this.ownersSearch(val, null)
			}
		},
		value (val) {
			if (val && this.names.indexOf(val) === -1) {
				this.getOwners(null, val)
			}
		}
	},
	methods: {
		copyOwnerCode (ownerCode) {
			this.$grv_clipboard.copyToClipboard(ownerCode)
			this.$EventDialer(
				'success',
				false,
				'Copié dans le presse-papier',
				ownerCode,
				2000
			)
		},
		ownersSearch: debounce(function (search, code) {
			if (!search && !code) return
			if (this.loading) return
			this.getOwners(search, code)
		}, 100),
		getOwners (search, code) {
			this.loading = true
			this.$EsMaestro.owner_search(search, code)
				.then(owners => {
					this.items = owners
					this.names = owners.map(owner => owner.name)
				})
				.catch(err => {
					console.log(err)
				})
				.finally(() => (this.loading = false))
		}
	},
	mounted () {
		if (this.value && this.names.indexOf(this.value) === -1) {
			this.getOwners(null, this.value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.dense_input
	>>>.v-select__selections
		margin-left: 0 !important
		flex-wrap: nowrap
		input
			margin-left: 0 !important
		.v-chip__content
			padding: 0 0 0 4px
</style>



// WEBPACK FOOTER //
// src/components/field_owner.vue